<div class="form-input">
    <mat-form-field [color]="color" [appearance]="outlined" [ngStyle]="{'maxWidth': maxWidth, 'width': width}">
        <mat-label>{{text}}</mat-label>
        <input matInput [type]="type" [name]="name" [formControlName]="formControlName" placeholder="" [disabled]="disabled">
        <mat-hint *ngIf="hintText">{{hintText}}</mat-hint>
        <mat-error *ngIf="errorMsg">{{errorMsg}}</mat-error>
    </mat-form-field>
</div>
